import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantBankService } from '../../services/wealthlane-finance-integration-services';

const useGetAllParticipantBankList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const allParticipantBankList = useQuery(
    ['getAllParticipantBankList'],
    async () => {
      return await handleRequest(
        ParticipantBankService.getApiFinanceIntegrationApiAppParticipantBankDropdownParticipantBankList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.accountName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );
  return allParticipantBankList;
};

export default useGetAllParticipantBankList;
